import {AxiosCall} from '../Network/AxiosCall';
import APPURL from '../Constants/URLConstants';

export const getCartList = async ({
  setIsLoading,
  selectedUser,
  pk_key,
  params,
}) => {
  try {
    setIsLoading(true);

    // make params string
    const paramsString = Object.keys(params)
      .map(key => `${key}=${params[key]}`)
      .join('&');

    const responseJson = await AxiosCall({
      method: 'GET',
      path: APPURL.URLPaths.cart + '?' + paramsString,
      pk_key,
      auth_key: selectedUser?.key.auth_key,
    });

    return responseJson?.data?.data;
    setIsLoading(false);
  } catch (error) {
    setIsLoading(false);
  }
};
